// -
import React from 'react';
import AbstractReactComponent from "./AbstractReactComponent";
import setInputFocus from "./utils/setInputFocus";

/**
 * Předek pro komponenty, které chtějí nastavovat focus po zobrazení, typicky se jedná o formuláře.
 *
 * Použití:
 *
 * class CustomKomponent extends FocusableReactComponent {
 *   componentDidMount() {
 *     // Po umístění komponenty chceme povolit nastavení focusu
 *     this.enableSetFocus(ReactDOM.findDOMNode(this.refs.form));
 *   }
 *
 *   componentDidUpdate() {
 *     // Po aktualizaci dom se nastaví focus pokud ještě nastaven nebyl
 *     this.setFocus(ReactDOM.findDOMNode(this.refs.form));
 *   }
 * }
 */
export default class FocusableReactComponent extends AbstractReactComponent {
    constructor(props) {
        super(props);

        this.focusWasSet = false;
        this.canSetFocus = false;
    }

    /**
     * Povolení od kdy je možné pokusit se nastavit focus, pokud je již možné focus nastavit na el, rovnou se to provede.
     * @param el element, ve kterém jsou prvky, které mají dostat focus, např. formulář
     */
    enableSetFocus = (el) => {
        // console.log("ENABLE SET FOCUS...");
        this.canSetFocus = true;
        this.setFocus(el);
    };

    /**
     * Pokus o nastavení focusu, pokud již focus byl nastaven, nic se neděje.
     * @param el element, ve kterém jsou prvky, které mají dostat focus, např. formulář
     */
    setFocus = (el) => {
        if (!this.focusWasSet && this.canSetFocus && el) {
            // console.log("SETTING FOCUS...", el);
            this.focusWasSet = true;
            setTimeout(() => {
                setInputFocus(el);
            }, 1);
        }
    }
}
